module.exports = __webpack_public_path__ + "static/img/icon-gift.479d8a40.png";